import React, { CSSProperties, FC, ReactNode, SyntheticEvent } from 'react'

import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { definitions } from 'api/generated/complaints'
import { VoidHandler } from 'common/types'
import { ButtonLink } from 'components/presentational/link'
import {
  TooltipCustomContent,
  TooltipComplaintListItem,
  ListComplaints,
} from 'components/presentational/Tooltip'

export const ComplaintListView: FC<{
  showRealComplaints: boolean
  complaintListNotReal: definitions['ComplaintCause'][]
  complaintListReal: definitions['ComplaintCause'][]
  closeComplains?: boolean
  onlyRealComplaints?: boolean
  muteContact?: ReactNode
  deleteContact?: ReactNode
  clearChat?: ReactNode
  photoVisibilityToggle?: ReactNode
  onHandleClose: VoidHandler
  onShowRealComplaintsToggle: (event: SyntheticEvent) => void
  onClickSendComplaint: (causeId: number) => void
}> = ({
  showRealComplaints,
  complaintListNotReal,
  complaintListReal,
  muteContact,
  deleteContact,
  closeComplains,
  onlyRealComplaints,
  clearChat,
  photoVisibilityToggle,
  onHandleClose,
  onShowRealComplaintsToggle,
  onClickSendComplaint,
}) => {
  return (
    <TooltipCustomContent>
      <Slider>
        <ListComplaints
          data-name="complaints-tooltip-list-not-real"
          style={!showRealComplaints ? showCss : hideCss}
        >
          {muteContact}
          {deleteContact}
          {complaintListNotReal.map(({ id, message }) => (
            <TooltipComplaintListItem key={id}>
              <ButtonLink
                id={id}
                onClick={() => onClickSendComplaint(id)}
                data-name={`complain-${id}-action`}
              >
                {message}
              </ButtonLink>
            </TooltipComplaintListItem>
          ))}
          <TooltipComplaintListItem>
            <ButtonLink
              onClick={onShowRealComplaintsToggle}
              data-name="go-to-real-complaints-action"
            >
              <FormattedMessage
                id="complaint.blocked"
                defaultMessage="Пожаловаться и заблокировать"
              />
            </ButtonLink>
          </TooltipComplaintListItem>
          {clearChat}
          {photoVisibilityToggle}
          {closeComplains && (
            <TooltipComplaintListItem>
              <ButtonLink onClick={onHandleClose} data-name="close-complaints">
                <FormattedMessage
                  id="form.button.cancel"
                  defaultMessage="Отмена"
                />
              </ButtonLink>
            </TooltipComplaintListItem>
          )}
        </ListComplaints>
        <ListComplaints
          data-name="complaints-tooltip-list-real"
          style={showRealComplaints ? showCss : hideCss}
        >
          {complaintListReal.map(({ id, message }) => (
            <TooltipComplaintListItem key={id}>
              <ButtonLink
                id={id}
                onClick={() => onClickSendComplaint(id)}
                data-name={`complain-${id}-action`}
              >
                {message}
              </ButtonLink>
            </TooltipComplaintListItem>
          ))}

          {!onlyRealComplaints && (
            <TooltipComplaintListItem>
              <ButtonLink
                onClick={onShowRealComplaintsToggle}
                data-name="go-to-not-real-complaints-action"
              >
                <FormattedMessage id="back" defaultMessage="Назад" />
              </ButtonLink>
            </TooltipComplaintListItem>
          )}
        </ListComplaints>
      </Slider>
    </TooltipCustomContent>
  )
}

export const Slider = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  align-items: flex-start;
  align-content: flex-start;
  cursor: default;
`

const hideCss: CSSProperties = {
  padding: 0,
  visibility: 'hidden',
  height: 0,
  opacity: 0,
  pointerEvents: 'none',
  minWidth: 0,
  fontSize: 0,
}

const showCss: CSSProperties = {
  visibility: 'visible',
  height: 'auto',
  minWidth: '100%',
  opacity: 1,
  pointerEvents: 'auto',
  fontSize: 'inherit',
}
